__turbopack_context__.v({
  "antena": "AstronautArtwork-module-scss-module__C0HU5G__antena",
  "antenaLeft": "AstronautArtwork-module-scss-module__C0HU5G__antenaLeft",
  "antenaRight": "AstronautArtwork-module-scss-module__C0HU5G__antenaRight",
  "antenaTip": "AstronautArtwork-module-scss-module__C0HU5G__antenaTip",
  "astronaut": "AstronautArtwork-module-scss-module__C0HU5G__astronaut",
  "astronautAntena": "AstronautArtwork-module-scss-module__C0HU5G__astronautAntena",
  "astronautBackpack": "AstronautArtwork-module-scss-module__C0HU5G__astronautBackpack",
  "astronautBody": "AstronautArtwork-module-scss-module__C0HU5G__astronautBody",
  "astronautGlass": "AstronautArtwork-module-scss-module__C0HU5G__astronautGlass",
  "astronautHand": "AstronautArtwork-module-scss-module__C0HU5G__astronautHand",
  "astronautHands": "AstronautArtwork-module-scss-module__C0HU5G__astronautHands",
  "astronautHelmet": "AstronautArtwork-module-scss-module__C0HU5G__astronautHelmet",
  "astronautWire": "AstronautArtwork-module-scss-module__C0HU5G__astronautWire",
  "blink": "AstronautArtwork-module-scss-module__C0HU5G__blink",
  "center": "AstronautArtwork-module-scss-module__C0HU5G__center",
  "circle": "AstronautArtwork-module-scss-module__C0HU5G__circle",
  "circleInner": "AstronautArtwork-module-scss-module__C0HU5G__circleInner",
  "circleMain": "AstronautArtwork-module-scss-module__C0HU5G__circleMain",
  "circleOuter": "AstronautArtwork-module-scss-module__C0HU5G__circleOuter",
  "crater": "AstronautArtwork-module-scss-module__C0HU5G__crater",
  "crater1": "AstronautArtwork-module-scss-module__C0HU5G__crater1",
  "crater2": "AstronautArtwork-module-scss-module__C0HU5G__crater2",
  "crater3": "AstronautArtwork-module-scss-module__C0HU5G__crater3",
  "crater4": "AstronautArtwork-module-scss-module__C0HU5G__crater4",
  "crater5": "AstronautArtwork-module-scss-module__C0HU5G__crater5",
  "crater6": "AstronautArtwork-module-scss-module__C0HU5G__crater6",
  "craters": "AstronautArtwork-module-scss-module__C0HU5G__craters",
  "earDown": "AstronautArtwork-module-scss-module__C0HU5G__earDown",
  "earUp": "AstronautArtwork-module-scss-module__C0HU5G__earUp",
  "floating": "AstronautArtwork-module-scss-module__C0HU5G__floating",
  "four": "AstronautArtwork-module-scss-module__C0HU5G__four",
  "four1": "AstronautArtwork-module-scss-module__C0HU5G__four1",
  "four2": "AstronautArtwork-module-scss-module__C0HU5G__four2",
  "glow": "AstronautArtwork-module-scss-module__C0HU5G__glow",
  "glow1": "AstronautArtwork-module-scss-module__C0HU5G__glow1",
  "glow2": "AstronautArtwork-module-scss-module__C0HU5G__glow2",
  "handLeft": "AstronautArtwork-module-scss-module__C0HU5G__handLeft",
  "handRight": "AstronautArtwork-module-scss-module__C0HU5G__handRight",
  "main": "AstronautArtwork-module-scss-module__C0HU5G__main",
  "oh": "AstronautArtwork-module-scss-module__C0HU5G__oh",
  "planet": "AstronautArtwork-module-scss-module__C0HU5G__planet",
  "sorry": "AstronautArtwork-module-scss-module__C0HU5G__sorry",
  "star": "AstronautArtwork-module-scss-module__C0HU5G__star",
  "stars": "AstronautArtwork-module-scss-module__C0HU5G__stars",
  "wrench": "AstronautArtwork-module-scss-module__C0HU5G__wrench",
});
